import { Membership, MembershipDto } from "./membership";
import { winnerTypeToString } from "./enum/winningType";
import { TicketCheckInStatus } from "./enum/ticketCheckInStatus";
import { Penalty, PenaltyDto } from "./penalty";
import i18next from "i18next";
import { Subscription, SubscriptionDto } from "./subscription";
import { EventReward, EventRewardDto } from "./eventReward";
import { Fan, FanDto } from "./fan";
import {
  ApplicantInputValue,
  ApplicantInputValueDto,
} from "./applicantInputValue";
import { Winner, WinnerDto } from "./winner";
import { Ticket, TicketDto } from "./ticket";
import { PenaltyCounts, PenaltyStatus } from "./penaltyStatus";
import { PenaltyType } from "./enum/penaltyType";

export interface FanCheckInInfoDto {
  winnerId: number;
  ticketCode: string;
  ticketStatus: string;
  eventReward: EventRewardDto;
  fan: FanDto;
  applicantInputValue: ApplicantInputValueDto;
  penalty: PenaltyDto;
  officialMemberships: MembershipDto[] | null;
  subscriptions: SubscriptionDto | null;
  winner: WinnerDto;
  ticket: TicketDto;
}

export class FanCheckInInfo {
  winnerId: number;
  ticketCode: string;
  ticketStatus: TicketCheckInStatus;
  eventReward: EventReward;
  fan: Fan;
  applicantInputValue: ApplicantInputValue;
  penalty: Penalty;
  officialMemberships: Membership[] | null;
  subscriptions: Subscription | null;
  winner: Winner;
  ticket: Ticket;

  constructor(dto: FanCheckInInfoDto) {
    this.winnerId = dto.winnerId;
    this.ticketCode = dto.ticketCode;
    this.ticketStatus =
      TicketCheckInStatus[dto.ticketStatus as keyof typeof TicketCheckInStatus];
    this.eventReward = new EventReward(dto.eventReward);
    this.fan = new Fan(dto.fan);
    this.applicantInputValue = new ApplicantInputValue(dto.applicantInputValue);
    this.penalty = new Penalty(dto.penalty);
    this.officialMemberships =
      dto.officialMemberships?.map((it) => new Membership(it)) || null;
    this.subscriptions =
      dto.subscriptions && new Subscription(dto.subscriptions);
    this.winner = new Winner(dto.winner, dto.eventReward);
    this.ticket = new Ticket(dto.ticket);
  }

  orderString() {
    return `${winnerTypeToString(this.winner.winningType)} ${i18next.t("userdetail_userinfo_numbering", { numbering: this.winner.sequenceNumber })}`;
  }

  tardyOrderString() {
    return `${i18next.t("userdetail_userinfo_late")} ${i18next.t("userdetail_userinfo_numbering", { numbering: this.ticket.tardySequenceNumber })}`;
  }

  isTardy() {
    return (
      this.ticketStatus === TicketCheckInStatus.CHECKED_IN &&
      this.ticket.isTardy
    );
  }

  penaltyStatus() {
    const counts = new PenaltyCounts(0, 0);
    this.penalty.violations?.forEach((it) => {
      if (it.type === PenaltyType.TICKET_TRANSFER) {
        counts.transfer++;
      } else if (it.type === PenaltyType.RULE_VIOLATION) {
        counts.violation++;
      }
    });
    return new PenaltyStatus({
      tardy: this.isTardy(),
      transfer: this.penalty.violations?.find(
        (it) =>
          it.type === PenaltyType.TICKET_TRANSFER &&
          it.eventId === this.eventReward.eventId &&
          it.eventRewardId === this.eventReward.rewardId,
      ),
      violation: this.penalty.violations?.find(
        (it) =>
          it.type === PenaltyType.RULE_VIOLATION &&
          it.eventId === this.eventReward.eventId &&
          it.eventRewardId === this.eventReward.rewardId,
      ),
      counts,
    });
  }
}
